<template>
  <div class="app-extended-page">

    <div class="row">
      <div class="col bg-white-circles pt-4 pb-5">
        <div class="text-left px-5 py-5 mx-2 mx-md-5 mt-4 rounded promo-bg">
          <h1 class="display-4 font-weight-bold text-white">Full Customization and Distribution Options</h1>
          <p class="text-lg text-white mb-4">The Extended License is More Flexible</p>
          <a class="btn btn-cta btn-lg px-4" :href="buyNow" target="_blank">Buy Now</a>
          <router-link class="btn btn-lg btn-outline-light ml-2 ml-md-4" to="/contact">Purchase Inquiries</router-link>
        </div>
        <div class="text-left px-5 py-3 mx-2 mx-md-4 mt-4">
          <h1 class="mb-2 font-weight-bold">Why Go Extended?</h1>
          <div class="color-divider mb-4"></div>
          <ul class="list feature-list text-lg">
            <li>Include gradients in distributed products (like templates).</li>
            <li>The entire library in an easy to parse format.</li> 
            <li>One time payment - no recurring fees.</li>
            <li>Distribute to the entire team.</li>
          </ul>
        </div>
        <div class="text-left px-5 py-3 mx-2 mx-md-4 mt-4">
          <h1 class="font-weight-bold">No Subscription Needed</h1>
          <div class="color-divider mb-4"></div>
          <ul class="list feature-list text-lg">
            <li>Buy once, use forever, no account needed.</li>
            <li>Free updates (new gradients) for the rest of the calendar year.</li>
            <li>Only pay to get future versions.</li>
          </ul>
        </div>

        <div class="text-left px-5 py-3 mx-2 mx-md-4 mt-4">
          <h1 class="font-weight-bold">Thousands of Customization Options</h1>
          <div class="color-divider mb-4"></div>
          <p class="text-lg">
            The perfect way to add variety to your application.  CSS Gradients are fast, lightweight, and easy to use.  The entire library is <strong>less than {{fileSize}}MB</strong>
          </p>
          <p class="text-lg">
            With the extended license you can let users customize their experience by selecting from all {{totalGrads}}+ options in the gradient library.  
          </p>
        </div>
        <div class="text-left px-5 py-3 mx-2 mx-md-4 mt-4">
          <h1 class="font-weight-bold">You Need the Extended License to</h1>
          <div class="color-divider mb-4"></div>
          <ul class="list feature-list text-lg">
            <li>Include gradients in projects that will be distributed (like templates).</li>
            <li>Let users customize an application or screen by selecting between gradients.</li>
            <li>Share the gradient files with other team members.</li>
          </ul>
        </div>
        <div class="text-left px-5 py-3 mx-2 mx-md-4 mt-4">
          <h1 class="font-weight-bold">Pricing &amp; Options</h1>
          <div class="color-divider mb-4"></div>
          <p class="text-lg">The extended bundle is <strong>$999 USD</strong>. </p>
          <p class="text-lg">
            You get full permissions to distribute all {{totalGrads}}+ gradients and images.  
            This is an <em>incredible deal</em> compared to other graphics packages.
          </p>
        </div>
        <div class="text-left px-4 px-sm-5 py-5-sm py-4 mx-2 mx-md-4 mt-4 rounded promo-bg">
          <a class="btn btn-lg btn-cta px-4" :href="buyNow" target="_blank">Buy Now</a>
          <router-link class="btn btn-lg btn-outline-light ml-2 ml-md-4" to="/contact">Purchase Inquiries</router-link>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import AboutNav from "@/components/AboutNav.vue"

export default {
  components: {
    AboutNav
  },
  data(){
    return {
      totalGrads: 2000,
      totalCollections: 40,
      fileSize: 3,
      buyNow: 'https://gumroad.com/products/ISluy/',
      freeBundle: 'https://gum.co/amdRH',
      allProducts: 'https://gumroad.com/gradientmagic'
    }
  } 
}
</script>

<style lang="scss" scoped>

.app-extended-page {
  margin-bottom: -1.5rem; // Too offset the footer

  .feature-list {
    li {
      margin-bottom: .5rem;
    }
  }
}
.text-lg {
  font-size: 1.5rem;
}

.color-divider {
  height: 6px;
  width: 100%;
  background-color: #6260e4;
  border-radius: 2px;
}

.bg-white-circles {
  background-image: radial-gradient(circle at 13% 47%, rgba(140, 140, 140,0.03) 0%, rgba(140, 140, 140,0.03) 25%,transparent 25%, transparent 100%),radial-gradient(circle at 28% 63%, rgba(143, 143, 143,0.03) 0%, rgba(143, 143, 143,0.03) 16%,transparent 16%, transparent 100%),radial-gradient(circle at 81% 56%, rgba(65, 65, 65,0.03) 0%, rgba(65, 65, 65,0.03) 12%,transparent 12%, transparent 100%),radial-gradient(circle at 26% 48%, rgba(60, 60, 60,0.03) 0%, rgba(60, 60, 60,0.03) 6%,transparent 6%, transparent 100%),radial-gradient(circle at 97% 17%, rgba(150, 150, 150,0.03) 0%, rgba(150, 150, 150,0.03) 56%,transparent 56%, transparent 100%),radial-gradient(circle at 50% 100%, rgba(25, 25, 25,0.03) 0%, rgba(25, 25, 25,0.03) 36%,transparent 36%, transparent 100%),radial-gradient(circle at 55% 52%, rgba(69, 69, 69,0.03) 0%, rgba(69, 69, 69,0.03) 6%,transparent 6%, transparent 100%),linear-gradient(90deg, rgb(255,255,255),rgb(255,255,255));
}

.promo-bg {
  background-image: radial-gradient(circle at 29% 55%, hsla(329,0%,99%,0.05) 0%, hsla(329,0%,99%,0.05) 4%,transparent 4%, transparent 44%,transparent 44%, transparent 100%),radial-gradient(circle at 85% 89%, hsla(329,0%,99%,0.05) 0%, hsla(329,0%,99%,0.05) 51%,transparent 51%, transparent 52%,transparent 52%, transparent 100%),radial-gradient(circle at 6% 90%, hsla(329,0%,99%,0.05) 0%, hsla(329,0%,99%,0.05) 53%,transparent 53%, transparent 64%,transparent 64%, transparent 100%),radial-gradient(circle at 35% 75%, hsla(329,0%,99%,0.05) 0%, hsla(329,0%,99%,0.05) 6%,transparent 6%, transparent 98%,transparent 98%, transparent 100%),radial-gradient(circle at 56% 75%, hsla(329,0%,99%,0.05) 0%, hsla(329,0%,99%,0.05) 16%,transparent 16%, transparent 23%,transparent 23%, transparent 100%),radial-gradient(circle at 42% 0%, hsla(329,0%,99%,0.05) 0%, hsla(329,0%,99%,0.05) 3%,transparent 3%, transparent 26%,transparent 26%, transparent 100%),radial-gradient(circle at 29% 28%, hsla(329,0%,99%,0.05) 0%, hsla(329,0%,99%,0.05) 51%,transparent 51%, transparent 75%,transparent 75%, transparent 100%),radial-gradient(circle at 77% 21%, hsla(329,0%,99%,0.05) 0%, hsla(329,0%,99%,0.05) 35%,transparent 35%, transparent 55%,transparent 55%, transparent 100%),radial-gradient(circle at 65% 91%, hsla(329,0%,99%,0.05) 0%, hsla(329,0%,99%,0.05) 46%,transparent 46%, transparent 76%,transparent 76%, transparent 100%),linear-gradient(45deg, rgb(83, 91, 235),rgb(76, 11, 174));
}
</style>